export default {
      id: "modal-close-usage",
      viewBox: "0 0 27 27",
      url: __webpack_public_path__ + "assets/img/svg/sprite.svg#modal-close",
      toString: function () {
        return this.url;
      }
    }